import { defineComponent as a, openBlock as o, createBlock as r, normalizeProps as n, guardReactiveProps as p, withCtx as l, renderSlot as s, createElementVNode as c } from "vue";
import i from "../CdrIcon.vue.mjs";
const m = /* @__PURE__ */ c("path", {
  role: "presentation",
  d: "M10 7a1 1 0 010 2H5v10h10v-5a1 1 0 012 0v6a.997.997 0 01-1 1H4a.997.997 0 01-1-1V8a.997.997 0 011-1zm10.007-4a.997.997 0 01.992 1.029V9a1 1 0 01-2 .004L19 6.42l-8.295 8.287a1 1 0 01-1.414-1.415L17.58 5H15a1 1 0 010-2z"
}, null, -1), f = /* @__PURE__ */ a({
  name: "ExternalLink",
  __name: "external-link",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (t, d) => (o(), r(i, n(p(e.props)), {
      default: l(() => [s(t.$slots, "default"), m]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
